import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Splash from "@/pages/Splash";
import Discover from "@/pages/Discover";
import Explore from "@/pages/Explore";
import LookDetail from "@/pages/LookDetail";
import StudioPage from "@/pages/Studio";
import Auth from "@/pages/Auth";
import Placeholder from "@/pages/Placeholder";
import BookingWizard from "@/pages/BookingWizard";
import Upcoming from "@/pages/Upcoming";
import KutzPass from "@/pages/KutzPass";
import ScanPass from "@/pages/ScanPass";
import ReviewForm from "@/pages/ReviewForm";
import ProWelcome from "@/pages/ProWelcome";
import Onboarding from "@/pages/Onboarding";
import ProDashboard from "@/pages/ProDashboard";
import AfterHoursRequest from "@/pages/AfterHoursRequest";
import AfterHoursMine from "@/pages/AfterHoursMine";
import ProRequests from "@/pages/ProRequests";
import Messages from "@/pages/Messages";
import SafetySheet from "@/pages/SafetySheet";
import HQLayout from "@/pages/hq/HQLayout";
import HQHome from "@/pages/hq/HQHome";
import HQBookings from "@/pages/hq/HQBookings";
import HQVerification from "@/pages/hq/HQVerification";
import HQDisputes from "@/pages/hq/HQDisputes";
import HQSafety from "@/pages/hq/HQSafety";
import HQAfterHours from "@/pages/hq/HQAfterHours";
import HQFinance from "@/pages/hq/HQFinance";
import HQMarketplace from "@/pages/hq/HQMarketplace";
import HQLookup from "@/pages/hq/HQLookup";
import HQAudit from "@/pages/hq/HQAudit";
import DemoSwitcher from "@/components/DemoSwitcher";

function ProtectedApp() {
  const { loading } = useAuth();
  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShowSplash(false), 1100);
    return () => clearTimeout(t);
  }, []);
  if (loading || showSplash) return <Splash />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/discover" replace />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/look/:id" element={<LookDetail />} />
        <Route path="/studio/:id" element={<StudioPage />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/booking/new/:studioId" element={<BookingWizard />} />
        <Route path="/upcoming" element={<Upcoming />} />
        <Route path="/saved" element={<Placeholder title="Saved" note="Looks and Studios you save appear here." />} />
        <Route path="/me" element={<Placeholder title="My KUTZ" note="Your account, verification, trust and settings live here." />} />
        <Route path="/pro/welcome" element={<ProWelcome />} />
        <Route path="/pro/onboarding" element={<Onboarding />} />
        <Route path="/my-studio" element={<ProDashboard />} />
        <Route path="/calendar" element={<ProDashboard />} />
        <Route path="/bookings" element={<ProDashboard />} />
        <Route path="/earnings" element={<ProDashboard />} />
        <Route path="/hq" element={<HQLayout />}>
          <Route index element={<HQHome />} />
          <Route path="bookings" element={<HQBookings />} />
          <Route path="verification" element={<HQVerification />} />
          <Route path="disputes" element={<HQDisputes />} />
          <Route path="safety" element={<HQSafety />} />
          <Route path="after-hours" element={<HQAfterHours />} />
          <Route path="finance" element={<HQFinance />} />
          <Route path="marketplace" element={<HQMarketplace />} />
          <Route path="lookup" element={<HQLookup />} />
          <Route path="audit" element={<HQAudit />} />
        </Route>
        <Route path="/map" element={<Placeholder title="Explore — Map View" note="Full-screen local map — post Stage 1." />} />
        <Route path="/kutz-pass/:bid" element={<KutzPass />} />
        <Route path="/scan-pass" element={<ScanPass />} />
        <Route path="/review/new/:bid" element={<ReviewForm />} />
        <Route path="/after-hours/new/:studioId" element={<AfterHoursRequest />} />
        <Route path="/after-hours/mine" element={<AfterHoursMine />} />
        <Route path="/pro/requests" element={<ProRequests />} />
        <Route path="/messages/:bid" element={<Messages />} />
        <Route path="/safety" element={<SafetySheet />} />
        <Route path="/safety/:bid" element={<SafetySheet />} />
        <Route path="*" element={<Placeholder title="Not found" note="This surface hasn't been built yet." />} />
      </Routes>
      <DemoSwitcher />
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ProtectedApp />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
